import styled from 'styled-components';
const IndexStyled = styled.div`
  /* background-color: #fff; */
  height: 100%;
  .single_component1 {
    margin-bottom: 0;
  }
  .single_component2 {
    margin-bottom: 24px;
  }
  .single_component {
    border-radius: 12px;
    /* border: 1px solid red; */
    background-color: #fff;
    margin-top: 24px;
    flex-grow: 1;
  }
  .action_btn_group {
    margin-right: 1rem;
    display: flex;
    > div {
      margin-right: 10px;
    }
  }
  .mm_content {
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  .contentMsg {
    text-align: center;
    margin-bottom: 10px;
    font-size: 18px;
  }

  .editDetail {
    display: flex;
    justify-content: center;

    > div {
      margin-right: 20px;
    }
  }
`;
export default IndexStyled;
